import { PowerSyncDatabase } from '@powersync/web'
import { AppSchema } from './schema'
import { setupConnection } from './setup'

export function createWebPowerSync(): PowerSyncDatabase | null {
  try {
    console.log('[PS-DIAG] creating PowerSyncDatabase (web)')
    return setupConnection(new PowerSyncDatabase({
      schema: AppSchema,
      database: { dbFilename: 'imki.sqlite' },
    }))
  } catch (e) {
    console.error('[PS-DIAG] PowerSyncDatabase init threw', e)
    return null
  }
}
